import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// import { animateScroll as scroll } from 'react-scroll'

// import { setBodyNoScroll } from '../../utils/common';

import style from './InvestmentLifecycle.module.scss';

const InvestmentLifecycle = props => {
    const { title, titleColor, description, items } = props;
    const [isHovering, setHovering] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isPopupClose, setIsPopupClose] = useState(false);
    const [popupDisplay, setPopupDisplay] = useState(false);
    const [currntOrder, setCurrentOrder] = useState(null);
    const [slideOrder, setSlideOrder] = useState(null);
    const slideEl = useRef(null);

    const onMouseEnter = order => {
        setHovering(true);
        setCurrentOrder(order);
    };
    const onMouseLeave = () => {
        if (!popupDisplay) {
            setHovering(false);
            setCurrentOrder(null);
        }
    };
    const openPopup = order => {
        setPopupDisplay(true);
        setCurrentOrder(order);
        setTimeout(() => {
            if (slideEl) slideEl.current.slickGoTo(order);
            setSlideOrder(order);
            setIsPopupOpen(true);
            onMouseLeave();
        }, 300);
    };

    const closePopup = () => {
        setIsPopupClose(true);
        setTimeout(() => {
            setPopupDisplay(false);
        }, 700);
        setTimeout(() => {
            setIsPopupClose(false);
            setIsPopupOpen(false);
        }, 800);
    };

    useEffect(() => {
        // setBodyNoScroll(popupDisplay);
        // return () => {
        //     setBodyNoScroll(false);
        // }
        // if (popupDisplay) {
        //     scroll.scrollMore(200);
        // }
    }, [popupDisplay]);

    useEffect(() => {
        function setWH () {
            const wh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            document.documentElement.style.setProperty('--vh', `${wh}px`);
        }
        window.addEventListener('resize', setWH);
        setWH();
        return () => {
            // window.removeEventListerner('resize', setWH);
        };
    });

    const sliderParams = {
        width: '100%',
        height: '100%',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        autoplay: false,
        speed: 400,
        cssEase: 'cubic-bezier(0.25,0.1,0.25,1)',
        draggable: false,
        swipe: true,
        afterChange: current => setSlideOrder(current),
    };

    const prev = () => {
        if (slideEl) slideEl.current.slickPrev();
    };

    const next = () => {
        if (slideEl) slideEl.current.slickNext();
    };

    const changeSilid = order => {
        if (slideEl) slideEl.current.slickGoTo(order);
    };

    return (
        <div className={style.el}>
            <div className={[style.container, 'container'].join(' ')}>
                <div className={style.content}>
                    <h2 className={[style.title, titleColor === 'Pink' ? style.titlePink : ''].join(' ')}>{title}</h2>
                    <div className={style.description} dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <div className={[style.circles, isHovering ? style.hover : null].join(' ')} onMouseLeave={onMouseLeave}>
                    {items &&
                        items.map((item, i) => {
                            return (
                                <div
                                    className={[
                                        style.item,
                                        isHovering && currntOrder === i ? style.active : style.scale,
                                        item.color === 'Orange' ? style.itemOrange : ''
                                    ].join(' ')}
                                    key={i}
                                    onMouseEnter={() => onMouseEnter(i)}
                                    onClick={() => openPopup(i)}
                                >
                                    <div className={style.itemInner}>
                                        <div className={['h1', style.number].join(' ')}>{item.number}</div>
                                        <div className={['h3', style.text].join(' ')}>{item.title}</div>
                                        <button className={style.button}>
                                            {item.cta.text}
                                            <span className='icon-arrow-right' />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
            {popupDisplay && (
                <div
                    className={[
                        style.popup,
                        isPopupOpen ? style.isPopupOpen : null,
                        isPopupClose ? style.isPopupClose : null,
                    ].join(' ')}
                >
                    <div className={style.background} onClick={closePopup} />
                    <div className={style.wrapper}>
                        <div className={style.main}>
                            <div className={style.header}>
                                <h2 className={[style.headline, titleColor === 'Pink' ? style.titlePink : ''].join(' ')}>{title}</h2>
                                <button className={style.close} onClick={closePopup} />
                            </div>
                            {items && (
                                <div className={style.content}>
                                    <div className={style.navigate}>
                                        {items.map((item, i) => {
                                            return (
                                                <div
                                                    className={[
                                                        style['navigate-item'],
                                                        slideOrder === i ? style.active : null,
                                                        item.color === 'Orange' ? style.itemOrange : ''
                                                    ].join(' ')}
                                                    onClick={() => changeSilid(i)}
                                                    key={i}
                                                />
                                            );
                                        })}
                                    </div>
                                    <div className={style.carousel}>
                                        <Slider {...sliderParams} ref={slideEl}>
                                            {items.map((item, i) => {
                                                return (
                                                    <div key={i}>
                                                        <div className={style['carousel-item']}>
                                                            <div className={style.carouselItemInner}>
                                                                <div className={['h1', style.title].join(' ')}>
                                                                    {item.title}
                                                                </div>
                                                                <div className={style.desc} dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                                            </div>
                                                        </div>
                                                        {item.disclaimerText !== '' && item.disclaimerText !== null && (
                                                            <div className={style.disclaimer} dangerouslySetInnerHTML={{ __html: item.disclaimerText }}></div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            )}
                            <div />
                        </div>
                        <div className={style.bottom}>
                            <button
                                type='button'
                                className={[style.button, style.prev, slideOrder === 0 ? style.hide : null].join(' ')}
                                onClick={prev}
                            >
                                <span className='icon-arrow-right' />
                            </button>
                            <button
                                type='button'
                                className={[
                                    style.button,
                                    style.next,
                                    slideOrder === items.length - 1 ? style.hide : null,
                                ].join(' ')}
                                onClick={next}
                            >
                                <span className='icon-arrow-right' />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

InvestmentLifecycle.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.array,
};

export default InvestmentLifecycle;
